<template>
  <div class="content">
    <iframe ref="iframe" :src="iframeSrc" id="iFrameId" class="d-none" />
    <div>
      <div class="card">
        <div class="card-header bg-white header-elements-inline">
          <div class="card-title">
            <h5 class="font-weight-semibold">
              <i class="fas fa-store mr-2" />{{ $t("Stores") }}
            </h5>
            <div class="">
              {{ $t("Visit or manage the following connected stores.") }}
            </div>
          </div>
        </div>
          
        <div class="card-body mb-0 p-0">
          <div v-if="preLoad">
            <div class="d-flex justify-content-between align-items-center p-3 border-bottom-1 border-grey-DFDFDF">
              <div class="d-flex">
                <div class="mr-2">
                  <button
                    type="button"
                    class="btn btn-primary nowrap"
                    @click="showAlert()"
                    :disabled="isCreatingStore.length > 0 || loadingGoShip || loadingGoSell"
                  >
                    <i class="fa-solid fa-circle-plus mr-2" />{{ $t("Create New Store") }}
                  </button>
                </div>
                <div class="form-group mb-0">
                  <div class="input-group mb-0"> 
                    <input
                      type="text"
                      class="form-control border-right-0"
                      @keydown.enter.prevent="search(query.q)"
                      :placeholder="$t('Search...')"
                      v-model="query.q"
                    >
                    <span class="input-group-append">
                      <button
                        class="btn btn-light btn-search border-left-0 bg-white rounded-0"
                        type="button"
                        @click="search(query.q)"
                      > 
                        <i
                          class="far fa-search"
                          style="color: #adadad;"
                        />
                      </button>
                    </span>
                  </div>
                </div>
                <div class="form-group mb-0">
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#modal_more_filters"
                    class="btn btn-outline-normal border-left-0 rounded-left-0 d-flex"
                  >
                    <i class="fas fa-sliders-v mr-2 mt-1" />{{ $t("More Filters") }} 
                    <span class="badge badge-secondary ml-2">
                      <span v-if="countFilter">{{ countFilter }}</span>
                    </span>
                  </button>
                  <ModalMoreFilters />
                </div>
              </div>
              <div>
                <i class="fa-solid fa-house-chimney-user mr-1" /><span>{{ $t("Number Of My Stores") }}</span> : 
                <span>{{ storeTotal }}</span>
              </div>
            </div>
          </div> 
        </div> 
        <div v-if="preLoad">
          <div class="card-body"> 
            <stores-component
              :filter-data="filterData"
              :plan-type="typeGosell"
              :loading-store="loadingGoSell"
              :temp-tenant="tempTenant"
              :get-user-id="getUserId"
              :store-images="storeimages"
              v-if="showStoreGosell"
            />
          </div>
          <div class="card-body"> 
            <stores-component
              :filter-data="filterData"
              :plan-type="typeGoship"
              :loading-store="loadingGoShip"
              :temp-tenant="tempTenant"
              :get-user-id="getUserId"
              :store-images="storeimages"
              v-if="showStoreGoship"
            />
          </div>
        </div>
        <div
          v-else
          class="p-3"
        >
          <placeholder-content is-load="true" />
        </div>
      </div>
    </div> 


    <div
      id="ModalAddNewStore"
      :class="['modal','fade', (!(!showCreateStore) && !(isCreatingStore.length) ? 'modal-right' : '') ]"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <div :class="['modal-dialog', (!(!showCreateStore) && !(isCreatingStore.length) ? 'modal-lg' : '') ]">
        <div class="modal-content">
          <div class="bg-dark border-bottom-0 modal-header">
            <h5 class="modal-title">
              {{ $t("Create Store") }}
            </h5>
            <button
              type="button"
              class="close"
              ref="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeAlert"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body p-0">
            <div v-if="!onloadModal">
              <div v-if="!showCreateStore">
                <store-limit
                  title="Reached Store Limit"
                  detail="You cannot create more store."
                />
              </div>
              <div v-else-if="isCreatingStore.length">
                <store-limit
                  title="Please wait!"
                  detail="The system is creating a store."
                />
              </div>
              <div v-else>
                <modal-add-new-store-component
                  v-if="showModal"
                  ref="modalNewStoreForm"
                  @onLoadingChange="onLoadingChange"
                />
              </div>
            </div>
            <div v-else>
              <div class="content">
                <placeholder-content is-load="true" />
              </div>
            </div>
          </div>
          <div
            class="justify-content-center modal-footer bg-light fixed-bottom"
            v-if="!(!showCreateStore) && !(isCreatingStore.length)"
          >
            <!-- <div class="justify-content-center modal-footer bg-light fixed-bottom"> -->
            <ladda
              slot="finish"
              text="Save"
              @click="formSubmit"
              :btn-class="'btn btn-primary'"
              :loading="loading"
              icon="<i class='fa-solid fa-floppy-disk'></i>"
            />
            <button
              type="button"
              class="btn btn-light"
              @click="onCancleForm"
              data-dismiss="modal"
            >
              {{ $t("Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header bg-white header-elements-inline">
        <div class="card-title">
          <h5 class="font-weight-semibold">
            <i class="fas fa-envelope-square mr-2" />{{ $t("Invitation") }}
          </h5>
          <div class="">
            {{ $t("All the invitation from other stores’ admin will be showing here.") }}
          </div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="invitations.length > 0">
          <div
            v-if="!onload"
            class="list-invite"
          >
            <h5 class="font-weight-semibold">
              {{ $t("My Invitation") }}
            </h5>
            <div
              v-for="invitation in invitations"
              :key="invitation.id"
              class="list-group-item-action   d-flex align-items-lg-center align-items-start border-bottom  mt-1 mt-lg-0 py-3 px-lg-4"
            >
              <span class="icon-store-custom mr-3"><i class="fal fa-envelope-open-text fa-1x" /></span>
              <div class="d-lg-flex flex-1 align-items-center justify-content-between">
                <div class="media-body">
                  <h6 class="media-title font-weight-semibold">
                    <b>{{ $t(invitation.tenant_name) }}</b>
                  </h6>
                  <p class="mt-1">
                    <b>{{ invitation.invited_by }}</b> {{ $t("invites you to join") }}
                    <!-- {{invitation}} -->
                  </p>
                </div>

                <button
                  @click="Accept(invitation.id , invitation.tenant_name)"
                  class="btn btn-outline-primary  mr-2 "
                >
                  <i class="far fa-house-return mr-2" />{{ $t("Accept") }}
                </button>
                <button
                  @click="Rejects(invitation.id)"
                  class="btn btn-outline-secondary "
                >
                  <i class="fal fa-sign-out mr-2" />{{ $t("Reject") }}
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <div>
              <placeholder-content is-load="true" />
            </div>
          </div>
        </div>
        <div
          v-else
          class="p-4 text-center"
        >
          {{ $t("No data Invitation") }}
        </div>
      </div>
    </div>
    <AnnouncementPopup 
      :announcement="announcement"
    />
  </div>
</template>

<script>
//components
import StoreLimit from "@/components/tenancy/admin/error-page/templates/StoreLimit.vue";
import StoresComponent from "./MyStores";
import CentralApi from '@/services/endpoint/central.service'
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import ModalAddNewStoreComponent from "./ModalAddNewStore";
import Ladda from '@/plugins/Ladda.vue'
import ModalMoreFilters from "./ModalMoreFilters";
import AnnouncementPopup from "./AnnouncementPopup";
import {
  setStoreInfo,
} from "../stores/Params.js";
import Cookies from "js-cookie";

export default {
    components: {
      StoresComponent,
      ModalAddNewStoreComponent,
      PlaceholderContent,
      StoreLimit,
      Ladda,
      ModalMoreFilters,
      AnnouncementPopup,
    },
    data() {
        return {
            announcement: [
              {
                id: null,
                description: null,
              }
            ],
            isCreatingStore: [],
            showCreateStore: false,
            canAccess: [],
            invitations: [],
            onload: true,
            onloadModal: true,
            // showStore : true,
            showClose : true,
            showModal : false,
            autoPopup : false,
            personalInviteId: '',
            loading:false,
            newStore: false,
            centralCurrentUser: {},
            filterData:{ 
                        "filter": 
                          { 
                          "roles": "", 
                          "sortby": "" ,
                          "plansGroup":"" 
                          }, 
                        "searchStore":"" ,
                      }, 
            isFilter: false,
            isadvanceFilter: false,
            countFilter: 0,
            filter: {
              roles: [],
              sortby: [],
              plansgroup:[],
            },
            query: {
                page : 1,
                perPage : 15,
                q : '',
                sortby: '',
                roles:'',
                plansGroup:''
            }, 
            searchStore:'', 
            storesTotalGoShip:false,
            storesTotalGoSell:false,
            preLoad:false,
            logloading: false,
            loadingGoShip: false,
            loadingGoSell: false,
            typeGoship:'goship',
            typeGosell:'gosell',
            createType:'',
            userDataRefer:'',
            showStoreGoship : true,
            showStoreGosell : true,
            isCreate : false,
            tempTenant : {},
            storeimages : {},
            iframeSrc : process.env.CENTRAL_APP_URL + '/iframe',
            getUserId : null
        }
    },
    computed:{
      storeTotal(){
        let storeTotal = 0;

        if(typeof this.storesTotalGoSell == 'number' && typeof this.storesTotalGoShip == 'number'){
          storeTotal = this.storesTotalGoSell + this.storesTotalGoShip;
          // console.log(storeTotal, 'storeTotal');
          if(storeTotal < 1){
            this.newRegisterCheck();
          } 
        }

        return storeTotal;
      }
    },
    async mounted() {
      this.preLoad = true;
      this.loadingGoShip = true;
      this.loadingGoSell = true; 

      let user = Cookies.get('userProfile') || Cookies.get('user')


      if(user) {
        user = JSON.parse(user)
      } else {

        const request = await CentralApi.User.getUserV2()

        Cookies.set('userProfile', JSON.stringify(request.data.data), { domain: '.' + process.env.CENTRAL_API_ROOT });

        user = request.data.data
      }
     
      this.getUserId = +user.global_id

      window.onmessage = ({data, origin}) => { 
        if(origin != process.env.CENTRAL_APP_URL) return
        if(typeof data === 'object' && 'event' in data) return
        this.storeimages = JSON.parse(data)
      };

      this.getAnnouncement();
      await this.getInvitationList();
    },
    async created() {
      const tenantFromCookies = Cookies.get('tempTenant')

      if(tenantFromCookies) this.tempTenant = JSON.parse(tenantFromCookies)
    },
    methods: {
      async getInvitationList() {
        const getDataStringFromCookie = () => {
          let i = 1
          let fullString = ""

          while (true) {
            const string = Cookies.get(`invitation-${i}`)
            
            if(string === undefined && i === 1) return {
              message : "cookie is not declare"
            }

            Cookies.remove(`invitation-${i}`, { domain: '.' + process.env.CENTRAL_API_ROOT })

            if(!string) break
            fullString = fullString + string
            i++
          }
          
          if(!fullString) return {
            message : "full string is empty"
          }

          let invitations = JSON.parse(fullString)

          const shortInvitation = {
              i : "id",
              in : "invited_by",
              t : "tenant_name",
            }

          invitations = invitations.map(item => {
            const obj = {}
            for (const [key, value] of Object.entries(item)) {
                obj[shortInvitation[key]] = value
            }
            return obj
          })
   
          return invitations
        }
        try {
          this.onload = true;
          const dataFromCookies = await getDataStringFromCookie()
        
          if(Array.isArray(dataFromCookies)) {
            this.invitations = dataFromCookies
            this.onload = false;
            return
          } 

          if("message" in dataFromCookies && dataFromCookies.message === "full string is empty") {
            this.invitations = []
          } else {
            const data = await CentralApi.Invitation.getInvitationListV2(`?page=1&limit=10`);
            this.invitations = data.data.data;
          }
          
          this.onload = false;
        } catch (error) {
          console.log({error})
          this.onload = false;
          console.error({getInvitationError:500})
        }
      },
      newRegisterCheck() {  
        let self = this;
        if(self.newStore) {
                if(self.showCreateStore){
                  if(self.invitations.length == 0) {
                  self.showModal = true;
                  setTimeout(function(){ 
                    self.$refs.modalNewStoreForm.checkDomainLoop(self.$refs.modalNewStoreForm.generateText(8));
                    self.$refs.modalNewStoreForm.activePlatform = 'gosell';
                    self.$refs.modalNewStoreForm.type = 'personal';
                    self.$refs.modalNewStoreForm.storeData = setStoreInfo();
                    self.$refs.modalNewStoreForm.submitStatus = false;
                    
                    // $('#ModalAddNewStore').modal('show');
                  },500);
                  }
            }
        }
        return true;
      },
      reloadStrore(createStoreType = null,searchAndFillter = false, tempTenant = null){
            this.createType = createStoreType;
            if(searchAndFillter){
              this.showStoreGosell = false; 
              this.showStoreGoship = false; 
              this.$nextTick(() => {
                this.showStoreGosell = true;
                this.showStoreGoship = true;  
              });
            }else{

              if(tempTenant) this.tempTenant = tempTenant

              if(createStoreType == 'gosell'){
                this.showStoreGosell = false; 
                this.$nextTick(() => {
                  this.showStoreGosell = true; 
                });
              }else{ 
                this.showStoreGoship = false; 
                this.$nextTick(() => {
                  this.showStoreGoship = true; 
                });
              } 
            } 
        // this.showStore = false; 
        // this.showStoreGoship = false; 
        // this.showStoreGosell = false; 
        // this.$nextTick(() => {
        //     this.showStore = true;
        //     if(createStoreType == 'gosell'){
        //       this.showStoreGoship = false; 
        //       this.showStoreGosell = true;
        //     }else{ 
        //       this.showStoreGoship = true; 
        //       this.showStoreGosell = false;
        //     }  
            
        // });
      },
      closeAlert(){
        this.autoPopup = false;
        if(!(!this.showCreateStore) && !(this.isCreatingStore.length)) this.onCancleForm()
      },
      async showAlert(planType = '') {
          await this.getLimitStrore();
          //******S */
          this.showModal = true;
          // this.createType = planType != '' ? planType : ;
          
          if(this.showCreateStore){
            this.$swal.fire({
            icon: 'warning',
            title: this.$t('Add New Store ?'),
            html: this.$t('We will require some information before starting.'),
            focusConfirm: true,
            showCancelButton: true,
            confirmButtonText: '<i class="fas fa-check-circle mr-2"></i>'+this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            iconColor: '#FF7043',
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary mr-2',
                cancelButton: 'btn btn-outline-normal'
            },
            }).then((result) => {  
                if (result.isConfirmed) {
                  if(!(!this.showCreateStore) && !(this.isCreatingStore.length)) {
                    this.$refs.modalNewStoreForm.checkDomainLoop(this.$refs.modalNewStoreForm.generateText(8));
                    this.$refs.modalNewStoreForm.activePlatform = 'gosell';
                    this.$refs.modalNewStoreForm.type = 'personal';
                    this.$refs.modalNewStoreForm.storeData = setStoreInfo(); 
                    this.$refs.modalNewStoreForm.submitStatus = false;
                    
                  }
                  
                  $('#ModalAddNewStore').modal('show')
                }
            })

          }else{
            $('#ModalAddNewStore').modal('show')
            
          }
      },
      async getLimitStrore(){
        
          let storeLimit = this.$store.state.central.centralUser.data.data.store_limit || 5;
        
          this.onloadModal = false;
         
          const request = await CentralApi.Tenant.getTotalStores();

          if(request.status != 200) {
            console.error('get total store error')
            return;
          }

          const total = request.data.data.total
        
          this.showCreateStore = total < storeLimit
          return true
      },
      Accept(invitationId, tenantName) {
          this.$swal({
          icon: "warning",
          iconColor: '#ff7043',
          title: this.$t("Accept Invitation?"),
          // text: "You won’t be able to undo this action.",
          html: this.$t("You will be able to access")+ ' ' +tenantName + ' '+ this.$t("as invited role"),
          showCancelButton: true,
          cancelButtonText: this.$t('Cancel'),
          confirmButtonText: '<i class="fas fa-check-circle mr-1"></i>' + this.$t('Confirm'),
          buttonsStyling: false,
          customClass: {
              confirmButton: "btn btn-primary mr-2",
              cancelButton: "btn btn-light",
          },
          focusConfirm: false,
        }).then(async (result) => {
            if (result.isConfirmed) {
              let resp = await CentralApi.Invitation.postAcceptInvitaion(invitationId);
                if (resp) {
                    if (resp.data.status == false) {
                      this.$toastr.e(
                          this.$t(resp.data.message),
                          "<span class='icon-blocked'></span>" + this.$t("Error")
                      );
                    }
                    location.reload();
                    this.onload = false;
                }
            }
        });
      },
      Rejects(invitationId) {
          this.$swal({
              icon: 'warning',
              iconColor: '#FF7043',
              title: this.$t('This action can not be undone.'),
              text: this.$t('Are you sure you cancel invite ?'),
              showCancelButton: true,
              confirmButtonText: '<i class="fas fa-check-circle mr-1"></i> ' + this.$t('Confirm'),
              cancelButtonText: this.$t('Cancel'),
              buttonsStyling: false,
              customClass: {
                  confirmButton: 'btn btn-primary mr-2',
                  cancelButton: 'btn btn-light'
              },
              focusConfirm: false

          }).then(async (result) => {
              if (result.isConfirmed) {
                  //this.$parent.reloadTab = true;
                  let resp =  await CentralApi.Invitation.deleteInvitaion(invitationId);
                  if (resp) {
                      location.reload();
                      this.onload = false;
                  }
              }
          });
      },
      formSubmit(){
        this.$refs.modalNewStoreForm.checkForm( );
      },
      onCancleForm(){
        this.$refs.modalNewStoreForm.cancleForm( );
      },
      onLoadingChange(loadingVal){
        this.loading = loadingVal
      },
      search(data,filterData = {}){ 
        this.loadingGoShip = true;
        this.loadingGoSell = true 
        this.filterData.filter.searchStore = data;
        this.reloadStrore('',true);
        this.showCreateStore =false;
      },
      async getAnnouncement(){
        let vm = this;

        const cookies = Cookies.get(`announcement`)
        Cookies.remove(`announcement`, { domain: '.' + process.env.CENTRAL_API_ROOT });

        if(cookies && cookies === "false") {
          return
        }

        await CentralApi.Announcement.getAnnouncement().then( async function(response) {
          if (response.data && response.data.data.length > 0) {
            vm.announcement = response.data.data;
            await vm.$nextTick();
            $("#announcement").modal("show");
          }
        }).catch((error) => {
          console.log(error);
        })
      }
    },
    watch: {
        countFilter(nval, oval){ 
          if(nval != 0){
            this.countFilter = nval;
          }
        },
        '$store.state.central.centralUser'(val){
          this.userDataRefer = val.data.data.user_data.refer
          this.centralCurrentUser = val
        }
    },
}
</script>
<style scoped>
.form-control:not(.border-1):not(.border-2):not(.border-3):focus {
    border-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/central/account/stores/StoreIndex.vue